var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2633_70110",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2633_70110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 19.5135C13.9565 17.7622 15.4536 16.0823 16.4914 14.474C17.5292 12.8657 18.0481 11.457 18.0481 10.248C18.0481 8.425 17.469 6.92633 16.3106 5.752C15.1523 4.57767 13.7155 3.9905 12.0001 3.9905C10.2848 3.9905 8.84798 4.57767 7.68965 5.752C6.53131 6.92633 5.95215 8.425 5.95215 10.248C5.95215 11.457 6.47107 12.8657 7.5089 14.474C8.54673 16.0823 10.0438 17.7622 12.0001 19.5135ZM12.0001 20.9403C11.8053 20.9403 11.6105 20.9067 11.4156 20.8395C11.2206 20.7722 11.0443 20.668 10.8866 20.527C9.98932 19.7 9.14957 18.8483 8.3674 17.972C7.5854 17.0958 6.90565 16.2199 6.32815 15.3443C5.75048 14.4686 5.2934 13.6007 4.9569 12.7405C4.6204 11.8802 4.45215 11.0493 4.45215 10.248C4.45215 7.94033 5.19857 6.07208 6.6914 4.64325C8.1844 3.21442 9.95398 2.5 12.0001 2.5C14.0463 2.5 15.8159 3.21442 17.3089 4.64325C18.8017 6.07208 19.5481 7.94033 19.5481 10.248C19.5481 11.0493 19.3799 11.8785 19.0434 12.7355C18.7069 13.5927 18.2515 14.4607 17.6771 15.3395C17.1026 16.2183 16.4244 17.0942 15.6424 17.9672C14.8604 18.8404 14.0206 19.6904 13.1231 20.5173C12.9678 20.6583 12.7912 20.764 12.5934 20.8345C12.3957 20.905 12.198 20.9403 12.0001 20.9403ZM12.0019 11.8652C12.4994 11.8652 12.9247 11.6881 13.2779 11.3338C13.6312 10.9794 13.8079 10.5535 13.8079 10.056C13.8079 9.5585 13.6307 9.13308 13.2764 8.77975C12.9221 8.42658 12.4961 8.25 11.9984 8.25C11.5009 8.25 11.0756 8.42717 10.7224 8.7815C10.3691 9.13583 10.1924 9.56183 10.1924 10.0595C10.1924 10.557 10.3696 10.9823 10.7239 11.3355C11.0782 11.6887 11.5042 11.8652 12.0019 11.8652Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOn);
export default __webpack_public_path__ + "static/media/location_on.a7942ebb5f67bf4ecdbb6d5d09d4878f.svg";
export { ForwardRef as ReactComponent };